import useMutationApi from 'src/api/useMutationApi';

interface MatchLineItemToProductVariantBody {
  stagedCustomerPurchaseOrderId: string;
  stagedCustomerPurchaseOrderLineItemIndex: number;
  customerId: string;
  productVariantId: string;
  customerDescription?: string;
  customerMainIdentifier?: string;
  allowCreateCustomerProduct?: boolean;
}

const useMatchLineItemToProductVariant = (onSuccess?: () => void) => {
  return useMutationApi<MatchLineItemToProductVariantBody>({
    endpoint: `accounts-receivable/staged-purchase-orders/customer-products/match`,
    method: 'POST',
    options: {
      onSuccess,
    },
  });
};

export default useMatchLineItemToProductVariant;
